module.exports = __webpack_public_path__ + "img/activeicon-relationship_chart_icon.6deb6bda.svg";